/**
 * ============================================================================
 * AJAX FORM HANDLER - React-like Experience
 * ============================================================================
 * Submits forms without page reload
 * Uses Alpine.js for reactive updates
 * Fast, snappy, modern UX
 * ============================================================================
 */

document.addEventListener('alpine:init', () => {
  Alpine.data('ajaxForm', () => ({
    loading: false,
    success: false,
    error: false,
    message: '',
    
    async submitForm(e) {
      e.preventDefault();
      
      const form = e.target;
      const formData = new FormData(form);
      
      this.loading = true;
      this.success = false;
      this.error = false;
      this.message = '';
      
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        });
        
        if (response.ok) {
          this.success = true;
          this.message = 'Thank you! We\'ll be in touch soon.';
          form.reset();
          
          // Auto-hide success message after 5s
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else {
          throw new Error('Form submission failed');
        }
      } catch (error) {
        this.error = true;
        this.message = 'Oops! Something went wrong. Please try again.';
        console.error('Form error:', error);
      } finally {
        this.loading = false;
      }
    }
  }));
  
  // Cart drawer management
  Alpine.data('cartDrawer', () => ({
    open: false,
    itemCount: 0,
    items: [],
    loading: false,
    
    async addToCart(variantId, quantity = 1) {
      this.loading = true;
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        });
        
        if (response.ok) {
          await this.updateCart();
          this.open = true;
          
          // Show success animation
          this.showAddedAnimation();
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        alert('Failed to add item to cart. Please try again.');
      } finally {
        this.loading = false;
      }
    },
    
    async updateCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        this.items = cart.items;
        this.itemCount = cart.item_count;
      } catch (error) {
        console.error('Cart update error:', error);
      }
    },
    
    async removeItem(lineIndex) {
      this.loading = true;
      
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: lineIndex,
            quantity: 0
          })
        });
        
        if (response.ok) {
          await this.updateCart();
        }
      } catch (error) {
        console.error('Remove item error:', error);
      } finally {
        this.loading = false;
      }
    },
    
    showAddedAnimation() {
      // Trigger badge pulse animation
      const badge = document.querySelector('.xc-badge');
      if (badge) {
        badge.style.animation = 'none';
        setTimeout(() => {
          badge.style.animation = 'badgePulse 0.5s ease-out';
        }, 10);
      }
    },
    
    init() {
      // Load cart on page load
      this.updateCart();
    }
  }));
});

// Smooth scroll to section (for anchor links)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

// Lazy load images with intersection observer
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      }
    });
  }, {
    rootMargin: '50px'
  });
  
  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}

// Performance: Reduce paint flashing
if (CSS.supports('content-visibility', 'auto')) {
  document.querySelectorAll('.shopify-section').forEach(section => {
    section.style.contentVisibility = 'auto';
  });
}

